<template>
  <div class="container">

    <div class="w box_sizing width_box">

      <div class="banner_detail box_sizing">
        <!-- 提示音 -->
        <audio ref="audio" src="../../assets/dou.mp3"></audio>
        <div style="font-size: 18px;font-weight: 600;margin-bottom: 20px;">{{ name }}</div>
        <div class="listTitle flex_box flex_justify_between flex_align_center box_sizing">
          <!-- 提示音 -->
          <audio ref="audio" src="../../assets/yinxiao.mp3"></audio>
          <div style="color: #8C9198;">{{ suoYin }}/{{ topic_all_num }}</div>
          <div>模块作答倒计时：{{ exam_surplus_sort_date }}</div>
        </div>
        <div style="padding: 56px 0" class="box_sizing">
          <div class="topic_type_name" v-if="tiXingType == 20 || tiXingType == 2 || tiXingType == 5">{{ detail.number }}</div>
          <div class="topic_type_name" v-else>{{ detail.name }}</div>
          <div class="topic_type_title">{{ detail.describe }}</div>
          <div v-if="tiXingType == 1">
            <div class="topic_type_timu_box box_sizing">
              <span v-for="(item, index) in detail.show_text" :key="index"
                :class="[
                  isSelectableShowTextItem(item) ? 'hand_change' : '',
                  index == start_index || index == end_index ? 'word_select_color' : (index > start_index && index < end_index ? 'word_color' : '')
                ]"
                @click="isSelectableShowTextItem(item) ? dianjiChoose(item, index) : null"
                v-html="renderShowTextItem(item)"></span>
            </div>
            <div class="topic_type_answer_box topic_type_answer_box2 box_sizing" style="min-height: 200px;margin-top: 50px;"
              v-if="daojishiTime >= 0">
              <div class="topic_type_answer_title">Recorded Answer</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;">Current Status:</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-if="audio_complete">Complete</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-else-if="!recordings">Recording in {{ daojishiTime }} seconds</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-else>Recording</div>

              <audio-cmponent ref="AudioC" :key="componentKey" @audioDuration="audioDuration"
                @GetAudioData="GetAudioDataEven" @BeginEven="BeginEvenF"></audio-cmponent>
            </div>
          </div>

          <div v-if="tiXingType == 2 || tiXingType == 4 || tiXingType == 5 || tiXingType == 26 || tiXingType == 27">
            <div class="mp3_tool mp3_tool2 box_sizing">
              <div>
                <mp3-tool ref="mp3" :key="componentKey2" :src-url="detail.file"></mp3-tool>
              </div>
            </div>
            <!-- 题目区域 -->
            <div class="topic_type_timu_box box_sizing" style="margin-bottom: 20px;" v-if="tiXingType == 26">
              <span v-for="(item, index) in filteredShowText" :key="index" class="panding_change"
                :class="{ hand_change: isSelectableShowTextItem(item) }"
                @click="isSelectableShowTextItem(item) ? dianjiClick(item) : null" v-html="renderShowTextItem(item)"></span>
            </div>
            <div class="topic_type_answer_box topic_type_answer_box2 box_sizing" v-if="!detail.image" style="min-height: 200px;">
              <div class="topic_type_answer_title">Recorded Answer</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;">Current Status:</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-if="audio_complete">Complete</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-else-if="!recordings">Recording in {{ daojishiTime }} seconds</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-else>Recording</div>
              <audio-cmponent ref="AudioC" :key="componentKey" @audioDuration="audioDuration"
                @GetAudioData="GetAudioDataEven" @BeginEven="BeginEvenF"></audio-cmponent>
            </div>
            <div v-else style="display: flex;justify-content: space-between;align-items: center;">
              <img class="my_quest3" style="width: 50%;" :src="detail.image"/>
              <div class="topic_type_answer_box topic_type_answer_box2 box_sizing" style="height: 200px;">
                <div class="topic_type_answer_title">Recorded Answer</div>
                <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;">Current Status:</div>
                <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-if="audio_complete">Complete</div>
                <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-else-if="!recordings">Recording in {{ daojishiTime }} seconds</div>
                <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-else>Recording</div>
                <audio-cmponent ref="AudioC" :key="componentKey" @audioDuration="audioDuration"
                  @GetAudioData="GetAudioDataEven" @BeginEven="BeginEvenF"></audio-cmponent>
              </div>
            </div>
          </div>

          <div v-if="tiXingType == 3" style="display: flex;">
            <div style="width: 50%;">
              <img class="my_quest3" :src="detail.image" />
            </div>
            <div style="width: 50%;">
              <div class="topic_type_answer_box topic_type_answer_box2 box_sizing" style="min-height: 200px;">
                <div class="topic_type_answer_title">Recorded Answer</div>
                <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;">Current Status:</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-if="audio_complete">Complete</div>
              <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-else-if="!recordings">Recording in {{ daojishiTime }} seconds</div>
                <div class="topic_type_tt" style="font-size: 14px;color: #666;margin-right: 8px;" v-else>Recording</div>
                <audio-cmponent ref="AudioC" :key="componentKey" @audioDuration="audioDuration"
                  @GetAudioData="GetAudioDataEven" @BeginEven="BeginEvenF"></audio-cmponent>
              </div>
            </div>
          </div>

          <div v-if='tiXingType == 9'>
            <!-- 题目区域 -->
            <div class="topic_type_timu_box box_sizing">
              <span v-for="(item, index) in filteredShowText" :key="index" class="panding_change"
                :class="{ hand_change: isSelectableShowTextItem(item) }"
                @click="isSelectableShowTextItem(item) ? dianjiClick(item) : null" v-html="renderShowTextItem(item)"></span>
            </div>
            <div class="dati_time box_sizing flex_box flex_align_center justify_end" v-if="daojishiTime > 0">
              {{ daojishiTime }}s后开始答题
            </div>
            <div class="dati_time box_sizing flex_box flex_align_center justify_end" v-else>
              答题时间：{{ datiTime }}
            </div>
            <div class="topic_type_answer_box box_sizing">
              <div class="my_questins4 flex_box">
                <div class="my_questins4_title flex_box" v-if="detail.extend">
                  {{ detail.extend.topic }}
                </div>
                <div class="my_questins4_box flex_box" v-if="detail.extend">
                  <div class="my_questins4_list flex_box" v-for="(item, index) in detail.extend.extend_MA" :key="index"
                    @click="selectDaan(index)">
                    <img v-if="item.select == 0" src="../../assets/images/checkbox_nochoose.png" />
                    <img v-else-if="item.select == 1" src="../../assets/images/checkbox_choose.png" />
                    <img v-else-if="item.select == 2" src="../../assets/images/zhengque_Icon@2x.png" />
                    <img v-else-if="item.select == 3" src="../../assets/images/guanbi_icon@2x.png" />
                    <div :class="[item.select == 2 ? 'my_questins4_color' : '']">
                      {{item.key}}. {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if='tiXingType == 11'>
            <div class="topic_type_timu_box box_sizing">
              <div class="dati_time box_sizing flex_box flex_align_center justify_end" v-if="daojishiTime > 0">
                {{ daojishiTime }}s后开始答题
              </div>
              <div class="dati_time box_sizing flex_box flex_align_center justify_end" v-else>
                答题时间：{{ datiTime }}
              </div>
              <span v-for="(item, index) in detail.extend.FIB" :key="index">
                <span v-if="item.index == 0" @click="dianjiClick(item.word)" v-html="item.word">
                </span>
                <span class="panding_change" :data-txt="item.word" v-else @dragenter="deagenterDiv"
                  @dragover="dragoverDiv" @drop="dropDiv" style="
                  height: 16px;
                  border-bottom: 1px solid rgba(6, 18, 30, 1);
                  width: 150px;
                  text-align: center;
                  margin: 3px;
                " v-html="daanObj[item.word]"></span>
                <span class="panding_change" v-if="spanShow && item.index == 1" :style="{
                  color: item.word === daanObj[item.word] ? '#0ff507' : 'red',
                }">&nbsp;({{ item.word }})&nbsp;</span>
              </span>
            </div>
            <div class="box_sizing flex_box flex-warp" style="width: 100%;">
              <div class="box_sizing flex_box flex-warp" style="width: 100%" v-if="detail.extend.keyword">
                <div v-for="(item, index) in detail.extend.keyword" :key="index">
                  <div class="yuansu_list box_sizing flex_box flex_align_center flex_justify_center" @drag="dragDiv"
                    @dragover="dropOver($event)" :draggable="true" :data-text="item"
                    @dragstart="(e) => dragstartHandler(e,index)" v-if="daanIndexArr.indexOf(index) < 0" v-html="item">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="tiXingType == 12">
            <div class="dati_time box_sizing flex_box flex_align_center justify_end">答题时间：{{datiTime}}
            </div>
            <div class="topic_type_timu_box box_sizing">
              <block v-for="(item, index) in detail.extend.FIB_RW" :key="index">
                <span v-if="typeof(item.word) == 'string'" v-html="item.word"></span>
                <select v-if="Array.isArray(item.word)" @change="selectChange(item, $event)">
                  <option value=""></option>
                  <option v-for="(items, indexs) in item.word" :value="items.word" :key='indexs'>{{ items.word }}
                  </option>
                </select>
                <span v-for="(items, indexs) in item.word" :value="items.word" :key='indexs' style="color: #0ff507;"
                  v-html="spanShow && items.daan == 1 ? items.word : ''"></span>
              </block>
            </div>
          </div>

          <div v-if="tiXingType == 20 || tiXingType == 13">
            <div class="dati_time box_sizing flex_box flex_align_center justify_end">答题时间：{{datiTime}}
            </div>
            <div class="mp3_tool mp3_tool2 box_sizing">
              <div style="margin: 20px 0px">
                <mp3-tool ref="mp3" :key="componentKey2" :src-url="detail.file"></mp3-tool>
              </div>
            </div>
            <div class="topic_type_answer_box box_sizing" style="min-height: auto;">
              <div :class="tiXingType == 20 ? 'topic_textarea_box' : 'topic_textarea_box_wfd'">
                <textarea placeholder="请输入" v-model="content" @keyup="computedWordCount()"></textarea>
              </div>
              <div class="" style="margin-bottom: 20px !important">
                Word：{{ wordCount }}
              </div>
            </div>
          </div>

          <div v-if="tiXingType == 6 || tiXingType == 7">
            <div class="topic_type_timu_box box_sizing">
              <span v-for="(item, index) in detail.show_text" :key="index"
                :class="{ hand_change: isSelectableShowTextItem(item) }"
                v-html='renderShowTextItem(item)'
                @click="isSelectableShowTextItem(item) ? dianjiClick(item) : null"></span>
            </div>
            <div class="dati_time box_sizing flex_box flex_align_center justify_end" v-if="daojishiTime > 0">
              {{ daojishiTime }}s后开始答题
            </div>
            <div class="dati_time box_sizing flex_box flex_align_center justify_end" v-else>
              答题时间：{{ datiTime }}
            </div>
            <div class="topic_type_answer_box box_sizing" style="height: auto">
              <div class="topic_textarea_box">
                <textarea placeholder="请作答" v-model="content" @keyup="computedWordCount()"></textarea>
              </div>
              <div class="">
                Word：{{ wordCount }}

              </div>
            </div>
          </div>

          <div v-if="tiXingType == 8">
            <div class="topic_type_timu_box box_sizing">
              <span v-for="(item, index) in filteredShowText" :key="index" class="panding_change"
                :class="{ hand_change: isSelectableShowTextItem(item) }"
                @click="isSelectableShowTextItem(item) ? dianjiClick(item) : null" v-html="renderShowTextItem(item)"></span>
            </div>
            <div class="topic_type_answer_box box_sizing">
              <div class="dati_time box_sizing flex_box flex_align_center justify_end">
                答题时间：{{ datiTime }}
              </div>
              <div class="my_questins4 flex_box">
                <div class="my_questins4_title flex_box" v-if="detail.extend">
                  {{ detail.extend.topic }}
                </div>
                <div class="my_questins4_box flex_box" v-if="detail.extend">
                  <div class="my_questins4_list flex_box" v-for="(item, index) in detail.extend.extend_SA" :key="index"
                    @click="selectDxDaan(index)">
                    <img v-if="item.select == 0" src="../../assets/images/weixuanzhong_icon@2x.png" />
                    <img v-else-if="item.select == 1" src="../../assets/images/xuanzhong_Icon@2x.png" />
                    <img v-else-if="item.select == 2" src="../../assets/images/zhengque_Icon@2x.png" />
                    <img v-else-if="item.select == 3" src="../../assets/images/guanbi_icon@2x.png" />
                    <div :class="[item.select == 2 ? 'my_questins4_color' : '']">
                      {{item.key}}. {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="tiXingType == 16 || tiXingType == 17 || tiXingType == 18">
            <div class="mp3_tool mp3_tool2 box_sizing">
              <div style="margin: 20px 0px">
                <mp3-tool ref="mp3" :key="componentKey2" :src-url="detail.file"></mp3-tool>
              </div>
            </div>
            <div class="topic_type_answer_box box_sizing">
              <div class="dati_time box_sizing flex_box flex_align_center justify_end" v-if="daojishiTime > 0">
                {{ daojishiTime }}s后开始答题
              </div>
              <div class="dati_time box_sizing flex_box flex_align_center justify_end" v-else>
                答题时间：{{ datiTime }}
              </div>
              <div class="my_questins4 flex_box">
                <div class="my_questins4_title flex_box" v-if="detail.topic_type_id == 16">
                  Click on the paragraph that best relates to the recording.
                </div>
                <div class="my_questins4_title flex_box" v-if="detail.topic_type_id == 17">
                  {{ detail.extend.topic }}
                </div>
                <div class="my_questins4_title flex_box" v-if="detail.topic_type_id == 18">
                  At the end of the recording, the last word or group of words has been replaced by a beep. Select the correct option to complete the recording.
                </div>
                <div class="my_questins4_box flex_box" v-if="detail.extend">
                  <div class="my_questins4_list flex_box" v-for="(item, index) in detail.extend.extend_SA" :key="index"
                    @click="selectDxDaan(index)">
                    <img v-if="item.select == 0" src="../../assets/images/weixuanzhong_icon@2x.png" />
                    <img v-else-if="item.select == 1" src="../../assets/images/xuanzhong_Icon@2x.png" />
                    <img v-else-if="item.select == 2" src="../../assets/images/zhengque_Icon@2x.png" />
                    <img v-else-if="item.select == 3" src="../../assets/images/guanbi_icon@2x.png" />
                    <div :class="[item.select == 2 ? 'my_questins4_color' : '']">
                      {{ item.key }}.{{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="tiXingType == 10">
            <!-- 段落排序 -->
            <div
              class="dati_time box_sizing flex_box flex_align_center justify_end"
            >
              答题时间：{{ datiTime }}
            </div>
            <div class="topic_type_answer_box box_sizing">
              <div class="flex_align_center flex_box">
                <div class="topic_type_answer_box box_sizing">
                  <div class="title17">Source</div>
                  <div class="flex_box flex_align_center box_sizing choose17" v-for="(item, index) in choose"
                    :key="index" :class="chooseOne == index ? 'choose' : ''"
                    draggable="true"
                    @drag="dragDiv"
                    @dragover="dropOver($event)"
                    :data-text="item"
                    @dragstart="(e) => dragstartHandler2(e, index)"
                    @click="chooseSource(index)">
                    <div class="p17">{{ item.show_index }}</div>
                    <div :class="chooseOne == index ? 'chooseP' : ''">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
                <img src="../../assets/images/choose.png" alt="" @click="exchange"
                  style="width: 44px; height: 44px; margin: 0 15px" />
                <div class="topic_type_answer_box box_sizing" style="position: relative"
                @dragenter="deagenterDiv"
                @dragover="dragoverDiv"
                @drop="dropDiv">
                  <div class="title17">Correct Answer</div>
                  <transition-group name="flip-list">
                    <div
                      class="flex_box flex_align_center box_sizing choose17"
                      v-for="(item, index) in rightChoose"
                      :key="index"
                      :class="chooseTwo == index ? 'choose' : ''"
                      draggable="true"
                      @dragstart="dragstart(item)"
                      @dragenter="dragenter(item)"
                      @dragend="dragend(item)"
                      @click="chooseCorrect(index)"
                    >
                      <div class="p17">{{ item.show_index }}</div>
                      <div :class="chooseTwo == index ? 'chooseP' : ''">
                        {{ item.content }}
                      </div>
                    </div>
                  </transition-group>
                  <div class="pic17">
                    <img src="../../assets/images/shang.png" alt="" @click="chooseUp" />
                    <img src="../../assets/images/xia.png" alt="" @click="chooseDown" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="tiXingType == 14">
            <div class="dati_time box_sizing flex_box flex_align_center justify_end">答题时间：{{datiTime}}
            </div>
            <div class="mp3_tool mp3_tool2 box_sizing">
              <div style="margin: 20px 0px">
                <mp3-tool ref="mp3" :key="componentKey2" :src-url="detail.file"></mp3-tool>
              </div>
            </div>
            <div class="topic_type_answer_box box_sizing">
              <div class="my_questins4 flex_box">
                <div class="my_questins4_title flex_box" v-if="detail.extend">
                  {{ detail.extend.topic }}
                </div>
                <div class="my_questins4_box flex_box" v-if="detail.extend">
                  <div class="my_questins4_list flex_box" v-for="(item, index) in detail.extend.extend_MA" :key="index"
                    @click="selectDaan(index)">
                    <img v-if="item.select == 0" src="../../assets/images/checkbox_nochoose.png" />
                    <img v-else-if="item.select == 1" src="../../assets/images/checkbox_choose.png" />
                    <img v-else-if="item.select == 2" src="../../assets/images/zhengque_Icon@2x.png" />
                    <img v-else-if="item.select == 3" src="../../assets/images/guanbi_icon@2x.png" />
                    <div :class="[item.select == 2 ? 'my_questins4_color' : '']">
                      {{item.key}}. {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="tiXingType == 15">
            <div class="dati_time box_sizing flex_box flex_align_center justify_end">答题时间：{{datiTime}}
            </div>
            <div class="mp3_tool mp3_tool2 box_sizing">
              <div style="margin: 20px 0px">
                <mp3-tool ref="mp3" :key="componentKey2" :src-url="detail.file"></mp3-tool>
              </div>
            </div>
            <div class="topic_type_answer_box box_sizing">
              <div class="topic_type_timu_now_box box_sizing">
                <block v-for="(item, index) in detail.extend.FIB" :key="index">
                  <span v-if='item.index == 0' v-html="item.word"></span>
                  <input type="text" class="kong" v-if="item.index == 1" :key="'fib-input-' + tiMuId + '-' + index" v-model="daanObj[item.word]" :data-daan='item.word' />
                </block>
              </div>
            </div>
          </div>

          <div v-if="tiXingType == 19">
            <div class="dati_time box_sizing flex_box flex_align_center justify_end">答题时间：{{datiTime}}
            </div>
            <div class="mp3_tool mp3_tool2 box_sizing">
              <div style="margin: 20px 0px">
                <mp3-tool ref="mp3" :key="componentKey2" :src-url="detail.file"></mp3-tool>
              </div>
            </div>
            <div class="topic_type_answer_box box_sizing">
              <span class="cuoci_ans hand_change" v-for="(item, index) in detail.extend.HIW"
                :class="[item.bg == 1 ? 'bg_ans' : '']" :key="index" @click="selectSpan(index)"
                v-html="item.word"></span>
            </div>
          </div>
          <div class="over flex_box">
            <div class="hand_hover nextP" @click="nextTiMu(-1)" :class="{ 'loading': nextLoading, 'disabled': nextLoading }">
              <i v-if="nextLoading" class="el-icon-loading"></i>
              {{ subtext }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AudioCmponent from "@/components/audiocmponent/examaudiocmponent.vue";
import "@/css/pagePing.css";
import Mp3Tool from "@/components/mp3Toolexam.vue";
import uploadFile from '@/common/ossUploader';
var intervalTime; // 时间
var daojishiSort;
var daojishiBo; // 题目准备时间倒计时
var _this;
export default {
  components: {
    AudioCmponent,
    Mp3Tool
  },
  data() {
    return {
      mokaoId: [],
      tiMuId: "",
      id: "",
      name: "",
      isLeft: true,
      user_exam_id: "",
      suoYin: 0,
      tiXingType: "",
      mouseStatus: false,
      recordings: false, // 标记是否在录音
      detail: {},
      auUrl: "", // 上传录音文件地址
      timeLen: 0,
      wordCount: 0,
      subtext: 'NEXT',
      daojishiTime: 0, //等待时间倒计时
      datiTime: "00:00:00",
      answerTime: 0,
      playStatus: false,
      spanShow: false,
      audio: null,
      tiemrs: "00:00:00",
      tijiaoId: '',
      ansId: '',
      bofangStatus: false,
      daanObj: {},
      daanIndexObj: {},
      daanIndexArr: [],
      drop_index: null,
      content: '',
      choose: [],
      rightChoose: [],
      chooseOne: -1,
      chooseTwo: -1,
      chooseTwoText: '',
      componentKey: 1,
      componentKey2: 1,
      topic_count: 0,
      topic_all_num: 0,
      exam_surplus: 0,
      exam_surplus_sort: 0,
      exam_surplus_sort_date: '',
      exam_topic_type_index: -1,
      audio_complete: false,
      exam_time_arr: [],
      speaking_arr: [1,2,3,4,5,26,27],
      exam_topic_type_end: 0,
      pendingModuleTopicId: '',
      pendingModuleSuoYin: 0,
      nextLoading: false, // 下一题按钮加载状态
      submitLoading: false, // 提交按钮加载状态
      start_index: -1,
      end_index: -1
    };
  },
  computed: {
    filteredShowText() {
      return (this.detail.show_text || []).filter(item => !this.isShowTextBreak(item));
    }
  },
  watch: {
    answerTime: {
      handler(newVal, oldVal) {
        console.log(`答题时间现在=============>`, newVal);
        console.log(`答题时间上次=============>`, oldVal);
        if (newVal == 0) {
          console.log(`答题时间结束了，该自动提交跳转到下一题了`, 11111111111111111111);
        }
      },
      deep:true
    }
  },
  created() {
    _this = this;
    _this.audio = new Audio();
    _this.getParams();
  },
  destroyed() {
    clearInterval(intervalTime);
    clearInterval(daojishiSort);
    clearInterval(daojishiBo);
  },
  methods: {
    normalizeShowTextItem(item) {
      if (item && typeof item === 'object' && !Array.isArray(item)) {
        return item;
      }
      return {
        word: item,
        is_select: item && item !== '&nbsp;' && item !== '<br/>' ? 1 : 0,
      };
    },
    getShowTextWord(item) {
      const value = this.normalizeShowTextItem(item).word;
      return value == null ? '' : String(value);
    },
    isSelectableShowTextItem(item) {
      return Number(this.normalizeShowTextItem(item).is_select) === 1;
    },
    isShowTextBreak(item) {
      return /^<br\s*\/?>$/i.test(this.getShowTextWord(item));
    },
    renderShowTextItem(item) {
      const word = this.getShowTextWord(item);
      if (this.isShowTextBreak(item)) {
        return '<br/>';
      }
      return word.replace(/ /g, '&nbsp;');
    },
    getRaSelectedWordData() {
      if (_this.tiXingType != 1 || _this.start_index < 0 || _this.end_index < 0) {
        return {
          isValid: false,
          wordCount: 0,
          text: ''
        };
      }
      const startIndex = Math.min(_this.start_index, _this.end_index);
      const endIndex = Math.max(_this.start_index, _this.end_index);
      let wordData = [];
      for (let i = startIndex; i <= endIndex; i++) {
        const currentItem = _this.detail.show_text[i];
        if (_this.isSelectableShowTextItem(currentItem)) {
          wordData.push(_this.getShowTextWord(currentItem));
        }
      }
      return {
        isValid: wordData.length >= 8 && wordData.length <= 14,
        wordCount: wordData.length,
        text: wordData.join(' ')
      };
    },
    dianjiChoose(item, index) {
      if (_this.tiXingType != 1 || !_this.isSelectableShowTextItem(item)) {
        return;
      }
      if (_this.start_index >= 0 && _this.end_index >= 0) {
        _this.start_index = index;
        _this.end_index = -1;
      } else if (index == _this.start_index) {
        _this.start_index = -1;
        _this.end_index = -1;
      } else if (_this.start_index >= 0) {
        _this.end_index = index;
      } else {
        _this.start_index = index;
      }
      if (_this.$refs.AudioC) {
        const startIndex = _this.end_index >= 0 ? Math.min(_this.start_index, _this.end_index) : _this.start_index;
        const endIndex = _this.end_index >= 0 ? Math.max(_this.start_index, _this.end_index) : _this.end_index;
        _this.$refs.AudioC.changeWordIndex(startIndex, endIndex);
      }
    },
    computedWordCount() {
      let value = _this.content;
      // 替换中文字符为空格
      value = value.replace(/[\u4e00-\u9fa5]+/g, " ");
      // 将换行符，前后空格不计算为单词数
      value = value.replace(/\r|^\s+|\s+$/gi, "");
      // 多个空格替换成一个空格
      value = value.replace(/\s+/gi, " ");
      // 更新计数
      var length = 0;
      var match = value.match(/\s/g);
      if (match) {
        length = match.length + 1;
      } else if (value) {
        length = 1;
      }
      _this.wordCount = length
    },
    // 进入页面倒计时40秒开始录音
    daojishiBack() {
      clearInterval(daojishiBo);
      daojishiBo = setInterval(() => {
        if (_this.daojishiTime <= 0) {
          let kouyu_arr = _this.speaking_arr;
          if(kouyu_arr.includes(_this.detail.topic_type_id)) {
          console.log('_this.recordings',_this.recordings);
            if(_this.recordings == false) {
              setTimeout(() => {
                //console.log('audioc');
                _this.$refs.AudioC.startRecorder();
                _this.getTime();
              }, 500);
            }
          }else{
            _this.getTime();
          }
          clearInterval(daojishiBo);
          _this.playStatus = true;
        } else {
          _this.daojishiTime--;
        }
      }, 1000);
    },
    audioDuration(e){
      _this.timeLen = e.duration; // 实际录音时长
      _this.datiTime = _this.formateSeconds(e.show_time); // 展示录音时长
    },
    // 点击词汇
    selectSpan(i) {
      // console.log("111");
      let listObj = _this.detail;
      if(listObj.extend.HIW[i].word != '&nbsp;') {
        listObj.extend.HIW.forEach((item, index) => {
          if (index == i && item.bg == 0) {
            item.bg = 1;
          } else if (index == i && item.bg == 1) {
            item.bg = 0;
          }
        });
      }
      _this.detail = listObj;
      _this.$forceUpdate();
    },

    // input change
    inputChange(e) {
      var daanObj = _this.daanObj;
      daanObj[e.target.dataset.daan] = e.target.value
      _this.daanObj = daanObj;
    },
    chooseSource(e) {
      //选择左边栏选项
      _this.chooseOne = e;
      _this.chooseTwoText = ''
      _this.chooseTwo = -1;
    },
    chooseCorrect(e) {
      //选择右边栏选项
      _this.chooseTwo = e;
      _this.chooseTwoText = _this.rightChoose[_this.chooseTwo]
      _this.chooseOne = -1;
    },
    exchange() {
      if (_this.chooseOne != -1) {
        var value = _this.choose[_this.chooseOne];
        _this.choose.splice(_this.chooseOne, 1);
        _this.rightChoose.push(value);
        _this.chooseOne = -1;
      } else if (_this.chooseTwo != -1) {
        var valueTwo = _this.rightChoose[_this.chooseTwo];
        _this.rightChoose.splice(_this.chooseTwo, 1);
        _this.choose.push(valueTwo);
        _this.chooseTwo = -1;
      } else {
        _this.$message.error("请选择要操作的选项！");
      }
    },

    chooseUp() {
      //上移
      var index = _this.chooseTwo;
      if (index != 0) {
        _this.rightChoose[index] = _this.rightChoose.splice(
          index - 1,
          1,
          _this.rightChoose[index]
        )[0];
        _this.chooseTwo--;
      } else {
        _this.$message.error("已经是第一个数据了，不可以上移了");
      }
    },
    chooseDown() {
      //下移
      var index = _this.chooseTwo;
      if (index != _this.rightChoose.length - 1) {
        _this.rightChoose[index] = _this.rightChoose.splice(
          index + 1,
          1,
          _this.rightChoose[index]
        )[0];
        _this.chooseTwo++;
      } else {
        _this.$message.error("已经是最后一个数据了，不可以下移了");
      }
    },

    shuffle: function () {
      this.rightChoose = _.shuffle(this.rightChoose);
    },
    // 记录初始信息
    dragstart: function (value) {
      this.oldNum = value;

      _this.isLeft = false;
    },
    // 做最终操作
    dragend: function (value) {
      if (this.oldNum != this.newNum) {
        let oldIndex = this.rightChoose.indexOf(this.oldNum);
        let newIndex = this.rightChoose.indexOf(this.newNum);
        let newItems = [...this.rightChoose];
        // 删除老的节点
        newItems.splice(oldIndex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(newIndex, 0, this.oldNum);
        // this.items一改变，transition-group就起了作用
        this.rightChoose = [...newItems];
        if(_this.chooseTwo > -1) {
          _this.rightChoose.forEach((item,index) => {
            if(item.show_index == _this.chooseTwoText.show_index) {
              _this.chooseTwo = index
            }
          })
        }
      }
    },
    // 记录移动过程中信息
    dragenter: function (value) {
      this.newNum = value;
    },

    // 点击事件
    dianjiClick(item) {
      const word = this.getShowTextWord(item).replace(/[.,!?;:'"()]/g, '').trim();
      if (!word || !this.isSelectableShowTextItem(item)) {
        return;
      }
      this.$refs.word.word_text = word;
      this.$refs.word.getWord();
    },

    // 在目标元素中移动
    dragoverDiv(e) {
      // console.log(e);
      e.dataTransfer.dropEffect = 'copy';
      e.preventDefault()
    },

    // 正在拖动
    dragDiv(e) {
      // console.log('正在拖动', e)
    },
    // 拖动开始
    touchstart() {
      console.log("11111");
    },
    // 拖动中
    touchmove() {
      console.log("222222");
    },
    // 拖动结束
    touchend() {
      console.log("33333");
    },

    // 阻止默认事件
    dropOver(e) {
      e.preventDefault(); // 在拖动中阻止默认事件
    },

    // 设置拖拽元素的方式
    deagenterDiv(e) {
      console.log('444444444444444444')
      // console.log(e)
      e.dataTransfer.dropEffect = 'copy';
      e.preventDefault();
    },

    // 开始拖拽
    dragstartHandler(e,index) {
      console.log('1212121212222222222222222222拖拽')
      console.log(e.target.dataset.text);
      e.dataTransfer.effectAllowed = "copy";
      e.dataTransfer.setData("copyKey", e.target.dataset.text);
      _this.drop_index = index;
      console.log('this.drop_index',index);
      // 获取拖拽的元素
    },
    // 开始拖拽
    dragstartHandler2(e, i) {
      console.log("1212121212222222222222222222拖拽");
      console.log("拖拽索引", i);
      _this.isLeft = true;
      e.dataTransfer.effectAllowed = "copy";
      e.dataTransfer.setData("copyKey", i);
      // 获取拖拽的元素
    },

    // 拖拽到此
    dropDiv(e) {
      if (_this.spanShow) {
        _this.$message.error("答题已完成不可再操作");
        return false;
      }
      if (_this.isLeft) {
        _this.rightChoose.push(_this.choose[e.dataTransfer.getData("copyKey")]);
        _this.choose.splice(e.dataTransfer.getData("copyKey"), 1);
      }
      // 将拖动元素旋转到目标区域中
      var copyKey = e.dataTransfer.getData("copyKey");
      console.log(copyKey);
      _this.daanObj[e.target.dataset.txt] = copyKey;
      console.log('xxxxxx',_this.daanObj,_this.daanIndexObj);
      if(_this.daanIndexObj[e.target.dataset.txt] >= 0) { // 判断是否已选择
        _this.daanIndexArr.splice(_this.daanIndexArr.indexOf(_this.daanIndexObj[e.target.dataset.txt]),1); // 删除对应的索引值
      }
      _this.daanIndexObj[e.target.dataset.txt] = _this.drop_index;
      _this.daanIndexArr.push(_this.drop_index);
      console.log('indexof',_this.daanIndexArr);
    },

    // 选择答案
    selectDaan(i) {
      let obj = _this.detail,
        strList = [];
      obj.extend.extend_MA.forEach((item, index) => {
        if (index == i && item.select == 0) {
          item.select = 1;
        } else if (index == i && item.select == 1) {
          item.select = 0;
        }
        if (item.select == 1) {
          strList.push(item.key);
        }
      });
      _this.detail = obj;
      _this.ansId = strList.join(",");
      console.log(_this.ansId);
    },
    // 录音开始
    BeginEvenF() {
      console.log(`点击开始录音======================>`);
      _this.daojishiTime = 0;
      if(_this.detail.topic_type_id != 2) {
        _this.$refs.audio.play(); //提示音效
      }
      _this.recordings = true;
      console.log("当前录音状态11", _this.recordings);
    },
    // 选择
    selectChange(obj, e) {
      var daanObj = _this.daanObj;
      for (let m = 0; m < _this.detail.extend.FIB_RW.length; m++) {
        if (
          typeof _this.detail.extend.FIB_RW[m].word === "object" &&
          _this.detail.extend.FIB_RW[m].word == obj.word
        ) {
          for (let n = 0; n < _this.detail.extend.FIB_RW[m].word.length; n++) {
            _this.detail.extend.FIB_RW[m].word[n].StyleColor = false;
          }
        }
      }
      obj.word.forEach((item) => {
        if (item.daan == 1) {
          daanObj[item.word] = e.target.value;
          // 判断选中答案是否与正确答案相等
          if (item.word.indexOf(e.target.value) !== -1) {
            //console.log("选中答案");
            // 相等后循环题目数组
            for (let i = 0; i < _this.detail.extend.FIB_RW.length; i++) {
              // 将题目数组中有答案选项的数组取出
              if (typeof _this.detail.extend.FIB_RW[i].word === "object") {
                // 循环答案选项数组
                for (
                  let j = 0;
                  j < _this.detail.extend.FIB_RW[i].word.length;
                  j++
                ) {
                  // 将选中的答案数组添加属性
                  // 重置属性值（选中正确答案后再选择错误答案，点击完成后即使是错误的也会显示绿色，所以再次处将所有属性重置未false）
                  if (
                    _this.detail.extend.FIB_RW[i].word[j].word.indexOf(
                      e.target.value
                    ) !== -1
                  ) {
                    _this.detail.extend.FIB_RW[i].word[j].StyleColor = true;
                  }
                  console.log(
                    " _this.detail.extend.FIB_RW[i].word[j]",
                    _this.detail.extend.FIB_RW[i].word[j]
                  );
                }
              }
            }
          }
        }
      });
      _this.daanObj = daanObj;
    },
    // 录音结束
    GetAudioDataEven(res) {
      console.log(`录音结束的res============>1111`, res);
      _this.recorderData = res.audio;
      _this.recordings = false;
      console.log("3333333_this.recordings",_this.recordings);
      _this.bofangStatus = true;
      // 手动获取录音时长
      // 页面上每道题的答题时间停止计时
      // recorder.play()
      _this.submitUp();
    },
    // 上传音频
    async submitUp() {
      console.log('485968459684568');
      let PCMBlob = _this.recorderData.WAV; //获取 PCM 数据
      _this.mouseStatus = true;
      try {
        const result = await uploadFile(PCMBlob);
        console.log('result',result);
        _this.auUrl = result.url;
        _this.auFullUrl = result.fullurl;
        if(_this.exam_topic_type_end == 1) {
          _this.exam_topic_type_end = 0;
          _this.submitTopic(2); // 模块答题结束
        } else {
          _this.submitTopic(-1);
        }
      } catch (error) {
        console.error('上传过程中出现错误:', error);
        _this.$notify.error({
          title: "提示",
          message: "录音上传失败请重试",
          duration: 1500,
        });
      }
    },
    // 提交这一道题,同时获取下一题
    submitTopic(is_end) {
      // 防止重复提交
      if (_this.submitLoading) {
        return;
      }

      // 设置提交加载状态
      _this.submitLoading = true;

      let params = _this.getTopicAnswer() // 获取提交的答案
      if (localStorage.getItem("token")) {
        params.is_end = is_end;
        console.log('params.content',params.content);
        console.log('params',params);
        _this.$axios
          .post("exam.user_exam/submit", params)
          .then((res) => {
            console.log(res);
            // 重置加载状态
            _this.submitLoading = false;
            _this.nextLoading = false;

            if (res.code == 1) {
              _this.bofangStatus = false;
              const isLastTopic = _this.tijiaoId == _this.mokaoId[_this.mokaoId.length - 1];
              if (isLastTopic && !(_this.pendingModuleTopicId && is_end == 2)) {
                _this.$message.success("考试完成");
                setTimeout(() => {
                  _this.$router.replace({
                    path: './mokaoScore',
                    query: {
                      user_exam_id: _this.user_exam_id
                    }
                  });
                }, 1500);
                return;
              }
              if (is_end == 2 && _this.pendingModuleTopicId) {
                _this.suoYin = _this.pendingModuleSuoYin;
                _this.tiMuId = _this.pendingModuleTopicId;
                _this.tijiaoId = _this.pendingModuleTopicId;
                _this.pendingModuleTopicId = '';
                _this.pendingModuleSuoYin = 0;
                _this.getTiMu()
              } else {
                _this.suoYin += 1;
                _this.tiMuId = _this.mokaoId[_this.suoYin-1];
                _this.tijiaoId = _this.mokaoId[_this.suoYin-1];
                if(is_end == -1) {
                  _this.getTiMu()
                }
              }
            } else {
              // _this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.error(err);
            // 重置加载状态
            _this.submitLoading = false;
            _this.nextLoading = false;
            // _this.$message.error(err.msg);
          });
      } else {
        _this.$message.error("您还没登录，请先登录");
        // 重置加载状态
        _this.submitLoading = false;
        _this.nextLoading = false;
      }
    },
    // 提交这一题，请求下一题
    nextTiMu(is_end) {
      // 防止重复点击
      if (_this.nextLoading) {
        return;
      }

      console.log('is_end',is_end);
      // 设置加载状态
      _this.nextLoading = true;

      // 如果是听力模块，停止所有正在播放的音频
      if (_this.$refs.mp3) {
        _this.$refs.mp3.stop();
      }
      let type_arr = [1,2,3,4,5,22,26,27];
      if(type_arr.includes(_this.tiXingType)) {
        if(is_end == -1) { // 手动点击的下一题，需要暂停录音并提交
          _this.$refs.AudioC.stopRecorder(is_end);
        }
      } else {
        _this.submitTopic(-1);
      }
    },
    // 获取题目列表
    getList() {
      var params = {
        exam_id: _this.id,
      };
      _this.$axios
        .post("exam.user_exam/create", params)
        .then((res) => {
          console.log(res);
          if (res.code == 1) {
            _this.user_exam_id = res.data.user_exam_id;
            _this.getMoKaoList();
          } else {
            _this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 获取模考题目
    getMoKaoList() {
      var params = {
        user_exam_id: _this.user_exam_id,
      };
      const loading = this.$loading({
        lock: true,
        text: '试卷正在加载中，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      _this.$axios
        .post("exam.user_exam/getInfo", params)
        .then((res) => {
          console.log(res);
          if (res.code == 1) {
            loading.close();
            _this.mokaoId = res.data.topic_ids;
            _this.tiMuId = res.data.topic_ids[0];
            _this.tijiaoId = res.data.topic_ids[0];
            console.log('get-tijiaoId',_this.tijiaoId);
            _this.exam_time_arr = res.data.exam_time;
            _this.exam_surplus = res.data.r_exam_time;
            _this.topic_count = res.data.count;
            _this.topic_all_num = res.data.all_num;
            _this.suoYin = res.data.count || 1;
            _this.getTiMu();
          } else {
            _this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 模块考试时间倒计时
    examSurplusSortInterval(topic_type_id)
    {
      console.log('topic_type_id',topic_type_id);
      let is_change = 0;
      let kouyu_arr = _this.speaking_arr;
      let writing_arr = [6,7];
      let reading_arr = [8,9,10,11,12];
      let listening_arr = [13,14,15,16,17,18,19,20];
      if(kouyu_arr.includes(topic_type_id) && _this.exam_topic_type_index != 0) {
        _this.exam_topic_type_index = 0;
        is_change = 1;
      } else if(writing_arr.includes(topic_type_id) && _this.exam_topic_type_index != 1) {
        _this.exam_topic_type_index = 1;
        is_change = 1;
      } else if(reading_arr.includes(topic_type_id) && _this.exam_topic_type_index != 2) {
        _this.exam_topic_type_index = 2;
        is_change = 1;
      } else if(listening_arr.includes(topic_type_id) && _this.exam_topic_type_index != 3) {
        _this.exam_topic_type_index = 3;
        is_change = 1;
      }
      console.log('is_change',is_change);
      if (is_change == 1) {
        clearInterval(daojishiSort)
        _this.exam_surplus_sort = _this.exam_time_arr[_this.exam_topic_type_index].time;
        console.log('exam_surplus_sort',_this.exam_surplus_sort);
        daojishiSort = setInterval(() => {
          if(_this.exam_surplus_sort <= 0) {
            if(_this.exam_topic_type_index == 3) {
              _this.submitTopic(1);
            } else {
              // 模块考试时间结束，自动跳转到下一模块
              _this.exam_topic_type_index++;
              _this.exam_surplus_sort = _this.exam_time_arr[_this.exam_topic_type_index].time;
              const nextModuleTopicId = _this.exam_time_arr[_this.exam_topic_type_index].first_topic_id;
              const nextModuleSuoYin = _this.mokaoId.indexOf(nextModuleTopicId) + 1;
              _this.pendingModuleTopicId = nextModuleTopicId;
              _this.pendingModuleSuoYin = nextModuleSuoYin;
              if(_this.exam_topic_type_index == 0) { // 口语模块
                if(_this.bofangStatus) { // 播放结束或未开始播放，直接提交
                  _this.submitTopic(2)
                } else { // 播放进行中，结束录音随后提交
                  _this.exam_topic_type_end = 1;
                  _this.$refs.AudioC.stopRecorder(-1);
                }
              } else {
                _this.submitTopic(2);
              }
            }
          } else {
            _this.exam_surplus_sort_date = _this.formateSeconds(_this.exam_surplus_sort);
            //console.log(_this.exam_surplus_sort_date);
            _this.exam_surplus_sort--;
          }
        },1000)
      }
    },

    // 获取时间
    getTime() {
      clearInterval(intervalTime);
      _this.timeLen=0;
      intervalTime = setInterval(() => {
        let kouyu_arr = _this.speaking_arr;
        if(kouyu_arr.includes(_this.detail.topic_type_id)) {
          if(_this.recordings == false && _this.timeLen) {
            _this.timeLen = _this.timeLen + 1;
            _this.datiTime = _this.formateSeconds(_this.timeLen);
          }
        } else {
          _this.timeLen = _this.timeLen + 1;
          _this.datiTime = _this.formateSeconds(_this.timeLen);
        }
        if(_this.timeLen>=_this.answerTime){
          clearInterval(intervalTime);
          console.log('321321321321');
          _this.nextTiMu(0); // 答题时间结束，自动获取下一题
        }
      }, 1000);
    },

    //将秒转化为时分秒
    formateSeconds(endTime) {
      let secondTime = parseInt(endTime); //将传入的秒的值转化为Number
      let min = 0; // 初始化分
      let h = 0; // 初始化小时
      let result = "";
      if (secondTime >= 60) {
        //如果秒数大于60，将秒数转换成整数
        min = parseInt(secondTime / 60); //获取分钟，除以60取整数，得到整数分钟
        secondTime = parseInt(secondTime % 60); //获取秒数，秒数取佘，得到整数秒数
        if (min >= 60) {
          //如果分钟大于60，将分钟转换成小时
          h = parseInt(min / 60); //获取小时，获取分钟除以60，得到整数小时
          min = parseInt(min % 60); //获取小时后取佘的分，获取分钟除以60取佘的分
        }
      }
      result = `${h.toString().padStart(2, "0")}:${min
        .toString()
        .padStart(2, "0")}:${secondTime.toString().padStart(2, "0")}`;
      return result;
    },

    // 选择答案
    selectDxDaan(i) {
      let obj = _this.detail;
      obj.extend.extend_SA.forEach((item, index) => {
        if (index == i) {
          item.select = 1;
          _this.ansId = item.key;
        } else {
          item.select = 0;
        }
      });
      _this.detail = obj;
    },

    // 获取模考题目
    getTiMu() {
      // 停止所有正在播放的音频
      console.log('mp3',_this.$refs.mp3);
      if (_this.$refs.mp3) {
        _this.$refs.mp3.stop();
      }
      _this.timeLen=0;
      _this.datiTime='00:00:00';
      _this.daanObj = {};
      _this.daanIndexObj = {};
      _this.daanIndexArr = [];
      _this.start_index = -1;
      _this.end_index = -1;
      var params = {
        topic_id: _this.tiMuId,
      };
      console.log('sdfsfdsdfsdfsfds');
      _this.$axios
        .post("exercise.topic/getExamTopicInfo", params)
        .then((res) => {
          console.log('getExamTopicInfo',res);
          if (res.code == 1) {
            _this.audio_complete = false;
            _this.tiXingType = res.data.topic_type_id;
            _this.daojishiTime = res.data.wait_time
            _this.answerTime = res.data.answer_time
            if (res.data.topic_type_id == 6 || res.data.topic_type_id == 7) {
              _this.content = '';
            } else if (res.data.topic_type_id == 9) {
              // 阅读多选
              res.data.extend.extend_MA.forEach((item) => {
                item.select = 0;
              });
            } else if (res.data.topic_type_id == 11) {
              // 阅读拖拽完型填空
              let obj = {};
              res.data.extend.FIB.forEach((item, index) => {
                console.log(typeof (item.word))
                if (typeof item.word != "string") {
                  item.word.forEach((items, indexs) => {
                    if (items.index == 1) {
                      obj[items.word] = "";
                    }
                  });
                }
              })
              _this.daanObj = obj;
            } else if (res.data.topic_type_id == 12) {
              // / 阅读下拉完型填空
              let obj = {};
              res.data.extend.FIB_RW.forEach((item, index) => {
                console.log(typeof (item.word))
                if (typeof item.word != "string") {
                  item.word.forEach((items, indexs) => {
                    if (items.daan == 1) {
                      obj[items.word] = "";
                    }
                  });
                }
              })
              _this.daanObj = obj;
            } else if (res.data.topic_type_id == 8) {
              //  阅读单选
              res.data.extend.extend_SA.forEach((item) => {
                item.select = 0;
              });
            } else if (res.data.topic_type_id == 10) {
              // 阅读排序
              _this.choose = res.data.extend.extend_sort;
            } else if (res.data.topic_type_id == 15) {
              // 听力填空 - 重新初始化答案对象，确保清空旧数据
              // 先完全清空，避免旧数据残留
              _this.daanObj = {};
              // 初始化新的答案对象，确保所有填空项都有初始值
              if (res.data.extend && res.data.extend.FIB) {
                res.data.extend.FIB.forEach((item, index) => {
                  if (item.index == 1) {
                    // 使用 $set 确保响应式
                    _this.$set(_this.daanObj, item.word, '');
                  }
                })
              }
            } else if (res.data.topic_type_id == 19) {
              res.data.extend.HIW.forEach(item => {
                item.bg = 0;
              })
            } else if (res.data.topic_type_id == 13 || res.data.topic_type_id == 20) {
              _this.content = '';
            } else if (res.data.topic_type_id == 14) {
              res.data.extend.extend_MA.forEach((item) => {
                item.select = 0;
              });
            } else if (res.data.topic_type_id == 16 || res.data.topic_type_id == 17 || res.data.topic_type_id == 18) {
              res.data.extend.extend_SA.forEach((item, index) => {
                item.select = 0;
              });
            }
            _this.detail = res.data;
            _this.auUrl = '';
            _this.wordCount = 0;
            _this.bofangStatus = false;
            _this.mouseStatus = false;
            _this.rightChoose = []
            _this.tiemrs = _this.formateSeconds(res.data.duration);
            if(_this.tiMuId == _this.mokaoId[_this.mokaoId.length-1]) {
              _this.subtext = 'Submit';
            }
            _this.getTime();
          } else {
            _this.$message.error(res.msg);
          }
          _this.examSurplusSortInterval(res.data.topic_type_id);
          let kouyu_arr = _this.speaking_arr;
          if(kouyu_arr.includes(res.data.topic_type_id)) {
            _this.daojishiBack();
            if(_this.componentKey > 1) {
              _this.$refs.AudioC.isVoice = 1;
            }
              _this.componentKey += 1;
              setTimeout(function(){
                _this.$refs.AudioC.changeTime({answer_time:_this.answerTime,allow_time:_this.answerTime-0.1});
                _this.$refs.AudioC.changeWordIndex(-1, -1);
              },200)
            }
          _this.$nextTick(()=>{
            let arr = [2,4,5,13,14,15,16,17,18,19,20,21,22,23,26,27];
            if(arr.includes(_this.tiXingType)) {
              _this.componentKey2 += 1;
              setTimeout(()=> {
                _this.$refs.mp3.play(); //自动播放音频
              },100)
            }
          })
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 获取题目提交的参数
    getTopicAnswer(){
      let params = {}
      if (_this.tiXingType == 1 || _this.tiXingType == 2 || _this.tiXingType == 3 || _this.tiXingType == 4 || _this.tiXingType == 5 || _this.tiXingType == 26 || _this.tiXingType == 27) {
        params = {
          user_exam_id: _this.user_exam_id,
          topic_id: _this.tijiaoId,
          content: _this.auUrl,
          exam_time: _this.timeLen,
        };
        if (_this.tiXingType == 1) {
          const selectedWordData = _this.getRaSelectedWordData();
          if (selectedWordData.isValid) {
            params.word_data = selectedWordData.text;
          }
        }
      } else if (_this.tiXingType == 9 || _this.tiXingType == 8 || _this.tiXingType == 14 || _this.tiXingType == 16 || _this.tiXingType == 17 || _this.tiXingType == 18) {
        params = {
          user_exam_id: _this.user_exam_id,
          topic_id: _this.tijiaoId,
          content: _this.ansId,
          exam_time: _this.timeLen,
        };
      } else if (_this.tiXingType == 19) {
        let objList = _this.detail.extend.HIW,
          list = [];
          objList.forEach((item) => {
            if (item.bg == 1) {
              list.push(item.word);
            }
        });
        params = {
          user_exam_id: _this.user_exam_id,
          topic_id: _this.tijiaoId,
          content: list.join(","),
          exam_time: _this.timeLen,
        };
      } else if (_this.tiXingType == 11 || _this.tiXingType == 12 || _this.tiXingType == 15) {
        params = {
          user_exam_id: _this.user_exam_id,
          topic_id: _this.tijiaoId,
          content: _this.daanObj,
          exam_time: _this.timeLen,
        };
      } else if (_this.tiXingType == 20 || _this.tiXingType == 13 || _this.tiXingType == 6 || _this.tiXingType == 7) {
        params = {
          user_exam_id: _this.user_exam_id,
          topic_id: _this.tijiaoId,
          content: _this.content,
          exam_time: _this.timeLen,
        };
      } else if (_this.tiXingType == 10) {
        // 阅读排序
        let str = [];
        _this.rightChoose.forEach((item) => {
          str.push(item.index);
        });
        params = {
          user_exam_id: _this.user_exam_id,
          topic_id: _this.tijiaoId,
          content: str.join(","),
          exam_time: _this.timeLen,
        };
      }
      return params;
    },

    // 获取传递过来的参数
    getParams() {
      _this.id = _this.$route.query.id;
      _this.name = _this.$route.query.name;
      if(_this.$route.query.user_exam_id) {
        _this.user_exam_id = _this.$route.query.user_exam_id
        _this.getMoKaoList();
      } else {
        _this.getList();
      }
    },

    // 返回上一页
    goBack() {
      _this.$router.go(-2);
    },
  },
};
</script>


<style>
.banner_detail {
  width: 100%;
  padding: 34px 35px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 1);
  text-align: left;
}

.listTitle {
  width: 100%;
  height: auto;
  padding: 11px 20px;
  background: #f9f9f9;
  opacity: 1;
}

.RA {
  width: 40px;
  height: 24px;
  border: 1px solid #f27f6d;
  opacity: 1;
  border-radius: 12px;
  text-align: center;
  line-height: 24px;
  color: #f27f6d;
}

.save {
  width: 97px;
  height: 24px;
  background: #f27f6d;
  opacity: 1;
  border-radius: 12px;
  text-align: center;
  line-height: 24px;
  color: #ffffff;
}

.teacher {
  width: 912px;
  height: 76px;
  border: 1px solid #bdc4ce;
  opacity: 1;
  border-radius: 10px;
  margin: 10px 0px 40px 0;
  padding: 19px 22px;
}

.teacher img {
  width: 40px;
  margin-right: 24px;
}

.play {
  width: 100%;
  height: auto;
  text-align: left;
  background: none;
}

.play .time {
  color: #8c9198;
  font-size: 12px;
  margin-left: 20px;
}

.play .progress {
  width: 300px;
  margin: 0;
}

.play .p3 {
  line-height: 22px;
  margin-bottom: 6px;
  font-size: 14px;
}

.yin {
  width: 20%;
  height: 26px;
  padding-top: 7%;
}

.yin img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.p2 {
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}

.p1 {
  width: 912px;
  height: auto;
  line-height: 22px;
  background: #f9f9f9;
  opacity: 1;
  padding: 35px;
  text-align: left;
}

.nextP {
  width: 78px;
  height: 30px;
  background: #f6704b;
  opacity: 1;
  border-radius: 4px;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nextP.loading {
  opacity: 0.7;
  cursor: not-allowed;
}

.nextP.disabled {
  pointer-events: none;
  opacity: 0.6;
}

.nextP .el-icon-loading {
  margin-right: 5px;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.over {
  width: 100%;
  justify-content: flex-end;
}

/* 答题结束弹框 */
.timeOver {
  width: auto;
  height: auto;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  color: #ffffff;
  text-align: center;
  padding: 30px 60px;
  position: fixed;
  top: 15%;
  left: 50%;
  z-index: 999;
}

.timeOver img {
  width: 50px;
  margin: 0 auto;
  height: 50px;

  margin-bottom: 24px;
}
.topic_type_answer_box {
  word-break: break-word;
}
.topic_type_answer_box2 {
  width: 300px;
  padding: 24px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.topic_type_answer_title {
  font-size: 18px;
}
.my_quest3 {
  width: 100%;
  height: auto;
}
.choose17 {
  height: auto;
}
.mp3_tool2 {
  margin-bottom: 58px;
  padding: 24px 22px;
}
.topic_textarea_box {
  height: 400px !important;
}
.topic_textarea_box_wfd {
  height: 150px !important;
}
.word_select_color {
  background: #f6704b;
}
.word_color {
  background: #f8a189;
}
.hand_change {
  display: inline-block;
  cursor: pointer;
}
</style>
